import { render, staticRenderFns } from "./bind-register.vue?vue&type=template&id=8e015f76&"
import script from "@/model/bindregister?vue&type=script&lang=js&"
export * from "@/model/bindregister?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports